module.exports = __webpack_public_path__ + "img/img3zhCn.f4ad1174.png";